function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable max-len */
/* eslint-disable dot-notation */
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { AgroHeaderContext } from '../../contexts/AgroHeaderContext/AgroHeaderContext';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { ScrollBarContainer } from '../../atoms/ScrollBarContainer/ScrollBarContainer';
import { Text } from '../../atoms/Text';
import { Box } from '../../atoms/Box';
import { Icard, Icart, IchatLeft, IchatRight, Ilist, Imoney, Itruck2, IavatarUser2, IarrowRight2, Inotify } from '../../atoms/AgroIcon/icons';
import { AgroSpinner } from '../../atoms/AgroSpinner';
var notifData = {
  ReceivedUnread: {
    icon: IchatLeft,
    href: '/myaccount/#/received/'
  },
  Sent: {
    icon: IchatRight,
    href: '/myaccount/#/sent/'
  },
  showOnTop: {
    icon: Inotify
  },
  showOnBottom: {
    icon: Inotify
  },
  SELLER_PENDINGRESPONSE: {
    icon: Icart,
    href: '/myaccount/#/sales?status=SELLER_PENDINGRESPONSE'
  },
  SELLER_PENDINGPAYMENT: {
    icon: Imoney,
    href: '/myaccount/#/sales?status=SELLER_PENDINGPAYMENT'
  },
  SELLER_PENDINGDELIVERY: {
    icon: Itruck2,
    href: '/myaccount/#/sales?status=SELLER_PENDINGDELIVERY'
  },
  BUYER_PENDINGACCEPTANCE: {
    icon: Ilist,
    href: '/myaccount/#/purchases?status=BUYER_PENDINGACCEPTANCE'
  },
  BUYER_PENDINGPAYMENT: {
    icon: Icard,
    href: '/myaccount/#/purchases?status=BUYER_PENDINGPAYMENT'
  },
  BUYER_PENDINGDELIVERY: {
    icon: Itruck2,
    href: '/myaccount/#/purchases?status=BUYER_PENDINGDELIVERY'
  }
};
var UserNotifications = withCssProps(function (_ref) {
  var data = _ref.data,
    loadingNotifications = _ref.loadingNotifications,
    tagManager = _ref.tagManager;
  var _useContext = useContext(AgroHeaderContext),
    baseUrl = _useContext.baseUrl,
    translations = _useContext.translations;
  // const [notifications, setNotifications] = useState([]);
  var notifications = [];
  data && Object.keys(data).map(function (key) {
    if (Array.isArray(data[key])) {
      data[key].map(function (n, idx) {
        notifications.push(_objectSpread(_objectSpread({}, data[key][idx]), {}, {
          icon: notifData[key].icon
        }));
      });
    } else {
      notifications.push(_objectSpread(_objectSpread({}, data[key]), {}, {
        icon: notifData[key].icon,
        href: notifData[key].href
      }));
    }
  });
  var getIcon = function getIcon(icon) {
    var Icon = icon;
    return /*#__PURE__*/React.createElement(Icon, {
      fill: "gray800",
      width: "24px",
      height: "24px"
    });
  };
  var handleClick = function handleClick(text) {
    if (tagManager) {
      var tagManagerArgs = {
        dataLayer: {
          event: 'trackEvent',
          eventCategory: 'My account',
          eventAction: text
        }
      };
      tagManager(tagManagerArgs);
    }
  };
  var showTranslation = function showTranslation(translation) {
    return translations[translation];
  };
  var redirect = function redirect(baseUrl, href, id) {
    if (id || id === 0) {
      var requestOptions = {
        method: 'PATCH',
        headers: {
          'Content-Type': 'Multipart/form-data'
        }
      };
      fetch("".concat(baseUrl, "/account/api/notifications/").concat(id), requestOptions);
      if (window && window.location) {
        window.location.href = href;
      }
    } else {
      if (window && window.location) {
        window.location.href = "".concat(baseUrl).concat(href);
      }
    }
  };
  return /*#__PURE__*/React.createElement(Notifications, {
    id: "user-notifications"
  }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(Text, {
    type: "subtitle-lg",
    color: "black",
    pl: "sm"
  }, showTranslation('notifTitle')), /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(AccountBtn, {
    onMouseDown: function onMouseDown() {
      return handleClick('Click - My account');
    },
    href: "".concat(baseUrl, "/myaccount/#/dashboard")
  }, /*#__PURE__*/React.createElement(IavatarUserIcon, {
    width: "16px",
    height: "16px",
    fill: "blue600",
    ml: "xs"
  }), /*#__PURE__*/React.createElement(Text, {
    color: "blue600",
    type: "label-sm",
    pr: "xxs"
  }, showTranslation('account'))), /*#__PURE__*/React.createElement(Btn, {
    onMouseDown: function onMouseDown() {
      return handleClick('Logout');
    },
    href: "".concat(baseUrl, "/customer/account/logout")
  }, /*#__PURE__*/React.createElement(Text, {
    color: "blue600",
    type: "label-sm",
    pr: "sm",
    pl: "xxs"
  }, showTranslation('logout'))))), /*#__PURE__*/React.createElement(Body, null, loadingNotifications ? /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    "justify-content": "center",
    my: "md"
  }, /*#__PURE__*/React.createElement(AgroSpinner, {
    size: "24px",
    variant: "gray"
  })) : !(notifications && notifications.length) ? /*#__PURE__*/React.createElement(Text, {
    display: "flex",
    py: "lg",
    "justify-content": "center"
  }, showTranslation('noNotif')) : /*#__PURE__*/React.createElement(Box, {
    mb: "xs"
  }, notifications.filter(function (item) {
    return item.count > 0;
  }).map(function (item, id) {
    return /*#__PURE__*/React.createElement(Notification, {
      key: id
      // href={`${baseUrl}${item.href}`}
      ,
      onClick: function onClick() {
        return redirect(baseUrl, item.href, item.id);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      display: "flex",
      "justify-content": "center"
    }, getIcon(item.icon)), /*#__PURE__*/React.createElement(Content, {
      display: "flex",
      "flex-direction": "column"
    }, /*#__PURE__*/React.createElement(Text, {
      pb: "xxs",
      type: "label-md",
      color: "gray900",
      dangerouslySetInnerHTML: {
        __html: item.text
      }
    }), /*#__PURE__*/React.createElement(Text, {
      color: "blue600",
      type: "subtitle-sm"
    }, item.linkText)), /*#__PURE__*/React.createElement(Arrow, {
      display: "flex",
      "justify-content": "center",
      "align-items": "center"
    }, /*#__PURE__*/React.createElement(IarrowRight2, {
      fill: "gray600"
    })));
  }))));
});
UserNotifications.propTypes = {
  data: PropTypes.object,
  loadingNotifications: PropTypes.bool
};
UserNotifications.displayName = 'UserNotifications';
export { UserNotifications };
var Notifications = styled.div.withConfig({
  displayName: "UserNotifications__Notifications",
  componentId: "sc-16ukb5v-0"
})(["background:#ffffff;box-shadow:0px 6px 10px rgba(0,0,0,0.15);border-radius:12px;position:absolute;z-index:200;top:40px;padding:0;color:#999;font-size:12px;right:0px;width:374px;font-family:", ";:after{content:'';position:absolute;display:block;right:40px;top:-8px;z-index:99999999;width:0;height:0;border-left:10px solid transparent;border-right:10px solid transparent;border-bottom:10px solid ", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.gray100;
});
var Body = styled(ScrollBarContainer).withConfig({
  displayName: "UserNotifications__Body",
  componentId: "sc-16ukb5v-1"
})(["overflow-y:auto;max-height:442px;min-height:40px;display:block;::-webkit-scrollbar{width:6px;}::-webkit-scrollbar-track{background:", ";}::-webkit-scrollbar-thumb{width:2px;background:", ";border-radius:15px;}::-webkit-scrollbar-thumb:hover{background:", ";}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.gray300;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.gray300;
});
var Header = styled.div.withConfig({
  displayName: "UserNotifications__Header",
  componentId: "sc-16ukb5v-2"
})(["background:", ";border-radius:12px 12px 0px 0px;line-height:35px;height:40px;display:flex;justify-content:space-between;align-items:center;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.gray100;
});
var IavatarUserIcon = styled(IavatarUser2).withConfig({
  displayName: "UserNotifications__IavatarUserIcon",
  componentId: "sc-16ukb5v-3"
})(["margin-right:5px;"]);
var Btn = styled.a.withConfig({
  displayName: "UserNotifications__Btn",
  componentId: "sc-16ukb5v-4"
})(["text-decoration:none;display:flex;align-items:center;height:40px;&:hover{background:rgba(0,80,138,0.05);}:last-child{border-top-right-radius:12px;}"]);
var AccountBtn = styled(Btn).withConfig({
  displayName: "UserNotifications__AccountBtn",
  componentId: "sc-16ukb5v-5"
})(["&:after{content:'';height:16px;border-right:1px solid ", ";}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.gray500;
});
var Notification = styled.a.withConfig({
  displayName: "UserNotifications__Notification",
  componentId: "sc-16ukb5v-6"
})(["text-decoration:none;cursor:pointer;border-bottom:2px solid ", ";display:flex;padding:20px 0px 20px 0px;:last-child{border-bottom:none;}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.gray200;
});
var Icon = styled(Box).withConfig({
  displayName: "UserNotifications__Icon",
  componentId: "sc-16ukb5v-7"
})(["margin:0px 12px 0px 24px;min-width:24px;"]);
var Arrow = styled(Box).withConfig({
  displayName: "UserNotifications__Arrow",
  componentId: "sc-16ukb5v-8"
})(["margin:0px 14px 0px 2px;min-width:24px;"]);
var Content = styled(Box).withConfig({
  displayName: "UserNotifications__Content",
  componentId: "sc-16ukb5v-9"
})(["flex-grow:1;"]);